import { ProfileContainer as Profile } from "./Profile.container";

// Default export needed
// eslint-disable-next-line import/no-default-export
export default Profile;
